module.exports = __webpack_public_path__ + "img/Feuilles-connexion@2x-100.ddf5943d.jpg";